import { Button, Radio } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const currentUser = useSelector((s: any) => s?.user?.data);

  const isAdmin = currentUser?.user?.roles?.some(
    (s: any) => s?.name === "admin"
  );
  let navigate = useNavigate();
  useEffect(() => {
    navigate(isAdmin ? "/admin/overview" : "/overview");
  }, []);

  return <div></div>;
}
